module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-excel-a13dfe30ac5bdcc4fff1ceb9fb02c611.svg";